import { App } from 'vue';
import Popper from './component/Popper.vue';

export default function config(app: App): void {
    app.component('Popper', Popper);
}
